import isEqual from "lodash/isEqual";

/**
 * Whether `current` differs from `initial` — for enabling an Update / Save
 * button only once the user has actually changed something.
 *
 * A deep comparison (lodash isEqual): nested objects and arrays are compared by
 * value, so a form state rebuilt on every keystroke still counts as unchanged
 * when the user types a character and deletes it again.
 *
 * Snapshot `initial` from the same shape the form edits, at the moment the form
 * is seeded — not from the raw API record, which usually carries fields the form
 * never touches and would always read as "changed".
 *
 *   const [initial, setInitial] = useState(null);
 *   // when seeding:  setInitial({ name, items });
 *   const dirty = initial !== null && hasChanges(initial, { name, items });
 */
export const hasChanges = (initial, current) => !isEqual(initial, current);

export default hasChanges;
